<template>
  <div
    class="app-wrapper"
    v-bind:class="{
      'sidebar-collapsed': sidebarCollapsed,
      'sidebar-open-mobile': sidebarCollapsedMobile
    }"
  >
    <Sidebar sidebarbg="bg-night-sky" />
    <div
      class="sidebar-mobile-overlay"
      v-on:click="toggleSidebarMobile"
      v-show="sidebarCollapsedMobile"
    ></div>
    <div class="app-main">
      <transition name="fade" mode="out-in" appear>
        <Header />
      </transition>
      <div class="app-content bg-white">
        <div class="app-content--inner" :style="mobileStyle">
          <slot></slot>
        </div>
        <transition name="fade" mode="out-in" appear>
          <Footer />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {
    Header: () => import("../Components/Header"),
    Sidebar: () => import("../Components/Sidebar"),
    Footer: () => import("../Components/Footer")
  },
  data() {
    return {
      mobileStyle: '',
      orientation: 'landscape',
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },
  computed: {
    sidebarCollapsed: {
      get() {
        return this.$store.state.sidebar.sidebarCollapsed;
      }
    },
    sidebarCollapsedMobile: {
      get() {
        return this.$store.state.sidebar.sidebarCollapsedMobile;
      },
      set(value) {
        this.$store.commit("sidebar/SET_SIDEBAR_COLLAPSED_MOBILE", value);
      }
    }
  },
  watch: {
    sidebarCollapsed: {
      handler() {
        setTimeout(() => {
          this.resizeWidth();
        }, 100);
      },
      deep: true,
    },
    sidebarCollapsedMobile: {
      handler() {
        setTimeout(() => {
          this.resizeWidth();
        }, 100);
      },
      deep: true,
    },
    orientation: {
      handler() {
        this.$store.commit("sidebar/SET_ORIENTATION", this.orientation);
      },
      deep: true,
    },
  },
  created() {
    window.addEventListener('resize', this.eventHandlerOrientation);
  },
  destroyed() {
    window.removeEventListener('resize', this.eventHandlerOrientation);
  },
  mounted() {
    this.orientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
    this.resizeWidth(true);
  },
  methods: {
    eventHandlerOrientation() {
      let orientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
      if (orientation != this.orientation) {
        this.orientation = orientation;
        setTimeout(() => {
          this.resizeWidth();
        }, 500);
      }
    },
    resizeWidth(first = false) {
      let wdgt_wrapper = document.getElementById("wdgt_wrapper");
      if (wdgt_wrapper) wdgt_wrapper.style.removeProperty("width");

      let w = 0;
      if (!first) {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
      }
      if (this.orientation == 'portrait') {
        w = this.width < this.height ? this.width : this.height;
      } else {
        w = this.width < this.height ? this.height : this.width;
      }
      if (this.width < 992) {
        this.mobileStyle = `max-width: ${w}px;`;
      } else {
        if (w < 1025) w = this.sidebarCollapsed ? w * 0.9 : w * 0.7;
        else if (w < 1280) w = this.sidebarCollapsed ? w * 0.91 : w * 0.72;
        else if (w < 1366) w = this.sidebarCollapsed ? w * 0.92 : w * 0.75;
        else if (w < 1450) w = this.sidebarCollapsed ? w * 0.925 : w * 0.77;
        else if (w < 1700) w = this.sidebarCollapsed ? w * 0.93 : w * 0.79;
        else w = this.sidebarCollapsed ? w * 0.94 : w * 0.82;

        this.mobileStyle = `max-width: ${w}px;`;
      } 
    },
    toggleSidebarMobile() {
      this.sidebarCollapsedMobile = !this.sidebarCollapsedMobile;
    }
  }
};
</script>
